import React from "react";

export const LazyWormCallPlayer = React.lazy(() =>
    import(/* webpackChunkName: "WormCall" */ "./Player").then(x => ({
        default: x.Player
    }))
);
